module.exports = __webpack_public_path__ + "img/11.3b8d0324.png";